import React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

type OptionTransferTouchGhostProps = {
  text: string;
  x: number;
  y: number;
  sx: SxProps<Theme>;
};

export const OptionTransferTouchGhost: React.FC<
  OptionTransferTouchGhostProps
> = ({ text, x, y, sx }) => (
  <Box
    sx={sx}
    style={{
      left: x,
      top: y,
    }}
  >
    {text}
  </Box>
);
